import Role from '@/models/system/role.js'
export default {
  data() {
    return {
      groupList: []
    }
  },
  created() {
    this.initGroupList()
  },
  methods: {
    /**
     * @desc 获取角色组列表
     */
    initGroupList() {
      Role.getRoleGroupList().then(res => {
        if (res.success) {
          this.groupList = res.result
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /**
     * @desc 获取角色权限列表
     */
    initRoleAuth() {
      let bizRoleId = this.roleId
      let data = {
        bizRoleId
      }
      Role.getRoleAuth(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            arr.push(i.id)
          })
          this.selectMenuAuth = arr
          this.isShow = false
          this.$nextTick(() => {
            this.isShow = true
          })
        } else {
          this.$message.error(res.message);
        }
      })
    },
  }
}